const parceSnils = (value: string): string => {
  if (typeof value !== 'string' || !value.length) return '';
  const [a, b, c, d] = value.match(/.{2,3}/g) as Array<string>;
  return `${a}-${b}-${c} ${d}`;
};

export default parceSnils;



// WEBPACK FOOTER //
// ./src/tools/parceSnils.ts